const e = {
  base: "peer shrink-0 appearance-none disabled:cursor-not-allowed disabled:opacity-50",
  solid: {
    checkbox: "h-6 w-6 rounded border border-grey-400 checked:bg-grey-600 checked:border-0",
    label: "text-grey-600 text-base leading-none",
    checkIcon: "absolute top-0.5 left-0.5 h-5 w-5 text-white hidden peer-checked:block pointer-events-none",
    container: "gap-2"
  },
  outline: {
    checkbox: "w-4 h-[17px] rounded-none border-2 border-grey-600",
    label: "text-grey-600 text-sm leading-none",
    checkIcon: "absolute top-[3.5px] left-[3px] h-2.5 w-2.5 hidden peer-checked:block pointer-events-none stroke-black stroke-[2]",
    container: "gap-1.5"
  }
};
export {
  e as styles
};
